<div class="alert" [ngClass]="type">
  <span class="icon">
    <ng-container [ngSwitch]="type">
      <span *ngSwitchCase="'success'">✅</span>
      <span *ngSwitchCase="'error'">❌</span>
      <span *ngSwitchCase="'warning'">⚠️</span>
      <span *ngSwitchCase="'info'">ℹ️</span>
    </ng-container>
  </span>
  <span class="message">{{ message }}</span>
  <button class="close-btn" (click)="close()">×</button>
</div>


